import { Link } from "@tanstack/react-router";
import { ChevronRight } from "lucide-react";
import { JsonLd } from "@/components/JsonLd";
import { breadcrumbSchema } from "@/lib/seo";

export type Crumb = { name: string; path: string };

/**
 * Visible breadcrumbs + BreadcrumbList JSON-LD.
 * Pass the full trail including Home as the first item and the current page last.
 */
export function Breadcrumbs({ items, className = "" }: { items: Crumb[]; className?: string }) {
  if (!items || items.length === 0) return null;
  return (
    <>
      <JsonLd data={breadcrumbSchema(items)} />
      <nav
        aria-label="Breadcrumb"
        className={`container-x pt-6 ${className}`}
      >
        <ol className="flex flex-wrap items-center gap-1.5 text-xs uppercase tracking-[0.18em] text-muted-foreground">
          {items.map((it, i) => {
            const isLast = i === items.length - 1;
            return (
              <li key={it.path} className="flex items-center gap-1.5">
                {isLast ? (
                  <span aria-current="page" className="text-foreground/80">
                    {it.name}
                  </span>
                ) : (
                  <Link
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    to={it.path as any}
                    className="hover:text-foreground transition-colors"
                  >
                    {it.name}
                  </Link>
                )}
                {!isLast && <ChevronRight size={12} className="opacity-50" />}
              </li>
            );
          })}
        </ol>
      </nav>
    </>
  );
}